export default __webpack_public_path__ + "static/media/cancer7.ddd3490c.jpg";